import { gearsMeta } from "@made-people/gears-remix";
import { rewriteUrlDomainBySiteSlug } from "./raw-response-routes/rewrite-sitemap-loc-domains";

/**
 * Start with the default meta output, then point alternate hreflang links
 * at the market-specific domains.
 */
export const missMaryMeta: typeof gearsMeta = (ctx) => {
  const meta = gearsMeta(ctx);

  return meta.map((entry) => {
    if (
      "href" in entry &&
      typeof entry.href === "string" &&
      "rel" in entry &&
      entry.rel === "alternate"
    ) {
      return { ...entry, href: rewriteUrlDomainBySiteSlug(entry.href) };
    }
    return entry;
  });
};
